import { useQuery } from "@tanstack/react-query";

import { fetchUserProfile } from "@/api/user";
import { useUserStore } from "@/stores/user";

export const useUserProfile = () => {
  const setProfile = useUserStore((state) => state.setProfile);

  return useQuery({
    queryKey: ["user", "profile"],
    queryFn: async () => {
      const data = await fetchUserProfile();
      setProfile(data);
      return data;
    },
    staleTime: 5 * 60 * 1000
  });
};
